module.exports = __webpack_public_path__ + "static/media/AISIdentify4Update.8af2d9b1.png";